<ul class="profile-reactions" [class.--is-desktop]="isDesktop">
  <li class="__reaction" [class.--is-desktop]="isDesktop">
    <ul
      (click)="toggleChildren()"
      class="__reactions-children"
      [class.--is-opened]="isInteractionsActionsOpened"
      [class.--is-closed]="!isInteractionsActionsOpened"
      [class.--has-active-item]="true"
      [class.--is-desktop]="isDesktop"
      [class.--has-no-active-item]="false"
    >
      <li class="__mask" [class.--is-desktop]="isDesktop" [class.--close-icon]="isInteractionsActionsOpened" [attr.data-index]="0">
        <mip-icon *ngIf="!isInteractionsActionsOpened" [size]="isMobile ? '8x' : '12x'" svgIcon="reactions"></mip-icon>
        <div *ngIf="!isInteractionsActionsOpened" class="info">
          <strong>{{ profile.userStats.reactionsReceived | millify : 2 : 10000 }}</strong>
        </div>
        <mip-icon size="6x" *ngIf="isInteractionsActionsOpened" icon="times"></mip-icon>
      </li>

      <li
        *ngFor="let item of reactions; let $index = index"
        class="__reaction --open"
        [class.--is-active]="isInteractionsActionsOpened"
        [class.--not-active]="!isInteractionsActionsOpened"
        [class.--is-desktop]="isDesktop"
        [attr.data-index]="$index + 1"
      >
        <button class="__reaction-button" mat-icon-button [class.--is-mobile]="isMobile" [class.--is-desktop]="isDesktop">
          <mip-icon
            [size]="isMobile ? '6x' : '10x'"
            [lottieIcon]="item.type + '-face'"
            [lottieAutoplay]="isInteractionsActionsOpened"
            [lottieStopFrame]="30"
            [lottieColored]="true"
          ></mip-icon>
        </button>
        <small *ngIf="item.total >= 0">{{ item.total }}</small>
      </li>
    </ul>
  </li>
</ul>
